import {
  Component,
  OnInit,
  Inject,
  Input,
  Output,
  ViewChild,
  ElementRef,
  HostListener,
  EventEmitter,
} from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import {
  slideInOutAnimation,
  overlayFadeInOutAnimation,
} from '../reusable-animations/card-estimate-drawer-animations';
import { MobileBreakPointsService } from 'src/app/services/mobileBreakPoints.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-dialog-location-map',
    templateUrl: './dialog-location-map.component.html',
    styleUrls: ['./dialog-location-map.component.scss'],
    animations: [slideInOutAnimation, overlayFadeInOutAnimation],
    standalone: false
})
export class DialogLocationMapComponent implements OnInit {
  google: any;
  flow: string;
  labels: any;
  isSupportPanelOpen: boolean = false;
  public toogleSupportPanel: EventEmitter<boolean> =
    new EventEmitter<boolean>();

  public isMobileSize: boolean;
  isMobile$: Observable<boolean>;
  private _displayMobile: boolean = true;
  public get displayMobile() {
    return this._displayMobile;
  }

  @ViewChild('menuOrDrawer', { static: false, read: ElementRef })
  menuOrDrawer!: ElementRef;
  @HostListener('document:click', ['$event'])
  handleClickOutside(event: Event) {
    if (
      this.menuOrDrawer &&
      !this.menuOrDrawer.nativeElement.contains(event.target)
    ) {
      this.isSupportPanelOpen = true;
    }
  }
  constructor(
    private _mobileBreakPoinntService: MobileBreakPointsService,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private dialogRef: MatDialogRef<DialogLocationMapComponent>
  ) {
    this.isMobile$ = this._mobileBreakPoinntService.mobileBreakPoints$;
  }

  ngOnInit(): void {
    this.google = this.dialogData.google;
    this.flow = this.dialogData.flow;
    this.labels = this.dialogData.labels;
    this.isSupportPanelOpen = this.dialogData.isSupportPanelOpen;
    this.isMobile$.subscribe((value) => {
      this.isMobileSize = value;
    });
  }

  upOnClose() {
    if(this.isMobileSize) {
      this.isSupportPanelOpen = true;
      this.dialogData.toogleSupportPanel(true);
    } else {
      this.isSupportPanelOpen = true;
      this.dialogData.toogleSupportPanel(false);
      this.dialogRef.close();
    }

    const delay = this.isMobileSize ? 500 : 0;
    setTimeout(() => {
      this.dialogRef.close();
    }, delay);
  }
}
